import { forwardRef } from "react";

const IconAnonymous = forwardRef<SVGSVGElement, { className?: string }>(({ className = "", ...props }, ref) => {
	return (
		<svg ref={ref} className={className} fill="none" stroke="currentColor" viewBox="0 0 14 14" {...props}>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.80709 5.77993c-0.02595 0.48144 0.36443 0.85568 0.84653 0.86213 1.06908 0.0143 2.50491 -0.03146 3.34611 -0.03146 0.84119 0 2.27703 0.04576 3.34607 0.03146 0.4821 -0.00645 0.8725 -0.38069 0.8466 -0.86213 -0.0725 -1.34356 -0.554 -2.87417 -0.851 -3.83792 -0.1281 -0.41556 -0.49703 -0.72306 -0.92979 -0.76564 -0.77578 -0.07634 -1.583 -0.1649 -2.41188 -0.1649 -0.82888 0 -1.63611 0.08856 -2.41189 0.1649 -0.43275 0.04258 -0.80172 0.35008 -0.92978 0.76564 -0.29699 0.96375 -0.77853 2.49436 -0.85097 3.83792Z"
				strokeWidth="1"
			/>
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M1 6.64478h12" strokeWidth="1" />
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.98188 10.7942c0.61785 -0.3989 1.41839 -0.3989 2.03624 0" strokeWidth="1" />
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M4.11686 12.8802c1.19666 0 1.86979 -0.6731 1.86979 -1.8698 0 -1.19665 -0.67313 -1.86978 -1.86979 -1.86978 -1.19667 0 -1.86979 0.67313 -1.86979 1.86978 0 1.1967 0.67312 1.8698 1.86979 1.8698Z"
				strokeWidth="1"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9.88248 12.9193c1.19662 0 1.86982 -0.6732 1.86982 -1.8698 0 -1.19669 -0.6732 -1.86981 -1.86982 -1.86981 -1.19666 0 -1.86978 0.67312 -1.86978 1.86981 0 1.1966 0.67312 1.8698 1.86978 1.8698Z"
				strokeWidth="1"
			/>
		</svg>
	);
});

IconAnonymous.displayName = "IconAnonymous";

export default IconAnonymous;
